/** External URLs used in navigation and CTAs */
export const CLIENT_PORTAL_URL = 'https://lidiana-cartolano.clientsecure.me/'
/** SimplePractice contact widget — submissions land directly in VIVA's inquiry system */
export const CONTACT_WIDGET_URL = 'https://lidiana-cartolano.clientsecure.me/contact-widget'
export const INSTAGRAM_URL = 'https://www.instagram.com/vivapsychotherapy'
